// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

// Define a service using a base URL and expected endpoints
export const customizeViewAboAssignmentAPI = createApi({
  reducerPath: "customizeViewAboAssignmentAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ["aboAssignView"],
  endpoints: (builder) => ({
    getAboAssignViewsList: builder.query<any, getViewArgsType>({
      query: ({ type }) => ({
        url: `/am/view/type/${type}`, // abo-assignment
        method: "GET",
      }),
      providesTags: ["aboAssignView"],
    }),
    getAboAssignViewDetailsById: builder.query<any, viewArgTypes>({
      query: ({ viewId }) => ({
        url: `/am/view/${viewId}`, // abo-assignment
        method: "GET",
      }),
    }),
    createAboAssignViews: builder.mutation<any, createViewArgsType>({
      query: ({ payload }) => ({
        url: `/am/view/create/type/abo-assignment`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["aboAssignView"],
    }),
    updateAboAssignViews: builder.mutation<any, updateViewArgsType>({
      query: ({ payload }) => ({
        url: `/am/view/update/type/abo-assignment`,
        method: "PUT",
        data: payload,
      }),
      // invalidatesTags: ["aboAssignView"],
    }),
    deleteAboAssignView: builder.mutation<any, viewArgTypes>({
      query: ({ viewId }) => ({
        url: `/am/view/${viewId}`,
        method: "delete",
      }),
      invalidatesTags: ["aboAssignView"],

    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAboAssignViewsListQuery,
  useLazyGetAboAssignViewsListQuery,
  useCreateAboAssignViewsMutation,
  useUpdateAboAssignViewsMutation,
  useDeleteAboAssignViewMutation,
  useLazyGetAboAssignViewDetailsByIdQuery
} = customizeViewAboAssignmentAPI;
